<script setup lang="ts">
import { useGetBanner } from '@/api/banner';
import LogoCompleteFa from '@/assets/images/logo-complete-fa.png';
import { setAuthLayoutCarouselItemsKey } from '@/helpers/eventBusKeys';
import { useBannersStore } from '@/stores/banners';

const router = useRouter();
const carouselBus = useEventBus(setAuthLayoutCarouselItemsKey);

const carouselItems = ref();

const currentRoute = computed(() => router.currentRoute.value);

const bannersStore = useBannersStore();

const { t } = useI18n();

const getBanner = async () => {
  const { data, error } = await useGetBanner();

  if (error) {
    return;
  }

  if (data?.result?.login_register && data.result?.login_register.status === true) {
    bannersStore.showAuthBanner(data.result?.login_register);
  }
};

carouselBus.on((carouseProps) => (carouselItems.value = carouseProps));

const goToWebsite = () => {
  // TODO: update this link with env variable
  window.open('https://www.skyroom.online', '_blank');
};

onMounted(() => {
  getBanner();
});
</script>

<template>
  <div :class="classes.layout">
    <div :class="classes.wrapper">
      <div v-if="bannersStore.activeBanner" :class="classes.banner">
        <Banner v-bind="bannersStore.activeBanner" />
      </div>

      <section :class="classes.container">
        <main :class="classes.main">
          <div :class="classes.header">
            <button :class="classes.brand" @click="goToWebsite">
              <img :src="LogoCompleteFa" alt="لوگو اسکای روم" :class="classes.logo" draggable="false" />
            </button>
            <h1 :class="classes.title">{{ t(currentRoute?.meta?.label as string) }}</h1>
          </div>

          <div :class="classes.content">
            <slot />
          </div>
        </main>

        <Carousel :items="carouselItems ?? []" :class="classes.carousel" />
      </section>
    </div>
  </div>
</template>

<style lang="scss" module="classes" src="./Auth.scss"></style>
